import { render, staticRenderFns } from "./Novidade.vue?vue&type=template&id=2f76dd16&scoped=true"
import script from "./Novidade.vue?vue&type=script&lang=js"
export * from "./Novidade.vue?vue&type=script&lang=js"
import style0 from "./Novidade.vue?vue&type=style&index=0&id=2f76dd16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f76dd16",
  null
  
)

export default component.exports